import StarterKit from "@tiptap/starter-kit";
import TaskList from "@tiptap/extension-task-list";
import TaskItem from "@tiptap/extension-task-item";
import type { TLRichText } from "@tldraw/tlschema";
import { richTextHtml } from "./canvas/engine/builtin/rich-label";

// Canvas writing, the expanded editor, measurement and export share one schema.
export const documentTextExtensions = [
  StarterKit.configure({ heading: { levels: [1, 2, 3] } }),
  TaskList,
  TaskItem.configure({ nested: true }),
];

const htmlCache = new WeakMap<TLRichText, string>();
export function nativeDocumentHtml(richText: TLRichText) {
  let html = htmlCache.get(richText);
  if (html === undefined) {
    html = richTextHtml(richText, documentTextExtensions);
    htmlCache.set(richText, html);
  }
  return html;
}

export function nativeDocumentPlaintext(richText: TLRichText) {
  type Node = { type?: string; text?: string; content?: Node[] };
  const read = (node: Node): string => {
    if (node.type === "text") return node.text ?? "";
    if (node.type === "hardBreak") return "\n";
    const text = (node.content ?? []).map(read).join("");
    return ["paragraph", "heading", "codeBlock"].includes(node.type ?? "")
      ? text + "\n"
      : text;
  };
  return read(richText as Node).trimEnd();
}
